import React, {useEffect, useState} from "react";
import { FiEye, FiEyeOff } from "react-icons/fi";
import AuthLayout from "../../components/Layouts/AuthLayout";
import Divider from "../../components/Divider";
import { useForm } from "react-hook-form";
import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import GoogleLogo from "../../assets/icons/google-logo.png";
import {Link} from "react-router-dom";
import { RouteNames } from "../../constants";
import { loginUser } from "../../redux/auth/authSlice";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../redux/hooks";
import LoadingSpinner from "../../components/LoadingSpinner";
import ErrorViewer from "../../components/ErrorViewer";
import {toast} from "react-toastify";
import {
    generateRecaptureLink,
    getKYCStatus,
    validateEmail, validatePhoneNumber,
    verifyEmail
} from "../../redux/selfService/selfServiceSlice";
import VerifyEmailOrPhone from "../../components/Auth/VerifyEmailOrPhone";
import SuccessModal from "../../components/SuccessModal";
import RecaptureModal from "../../components/Auth/RecaptureModal";
import ChangePasswordModal from "../../components/Auth/ChangePasswordModal";

const Login = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [showPassword, setShowPassword] = useState(false);
  const { isLoading } = useAppSelector((state) => state?.auth);
  const [showVerifyModal, setShowVerifyModal] = useState(false)
  const [successModalText, setSuccessModalText] = useState("")
  const [showSuccessModal, setShowSuccessModal] = useState(false)
  const [showChangePasswordModal,setShowChangePasswordModal] =useState(false)
  const [verifyItem, setVerifyItem] = useState<"email"|"phone">("email")
  const [showRecaptureModal, setShowRecaptureModal] = useState(false)

  const [showExpiryMessage, setShowExpiryMessage] = useState(true)
  useEffect(()=>{
    const queryParams = new URLSearchParams(window.location.search);
    if(showExpiryMessage &&queryParams.has('session-expired')){
      toast.error(`Session Expired \nPlease login again`);
    }
  }, [])

  const validationSchema = Yup.object().shape({
    userName: Yup.string().required("Email is required"),
    password: Yup.string().required("Password is required"),
  });

  const {
    handleSubmit,
    register,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(validationSchema),
    defaultValues: {
      userName: "",
      password: "",
    },
  });

  const onSubmit = async (values: any, e: any) => {
    e.preventDefault();
    const dispatchLogin = await dispatch(loginUser({
      ...values,
      deviceID: "web",
      DeviceVersion: "",
      AppVersion: "",
      DeviceOs: "",
      GcmId: ""
    }));
    console.log('dispatchLogin',dispatchLogin);
    if(dispatchLogin?.type === 'auth/login/fulfilled' || (dispatchLogin?.type === 'auth/login/rejected' && dispatchLogin?.payload?.statusCode==='03')){
        console.log('the dispatched login ', dispatchLogin)
        setTimeout(async ()=>{
          localStorage.setItem('enforceChangePassword','false');
          

          if(dispatchLogin?.payload?.statusCode==='03'){
             setShowExpiryMessage(false);
           
            
              setShowChangePasswordModal(true);
            localStorage.setItem('enforceChangePassword','true');
             // window.location.replace(RouteNames.ACCOUNT_SETTINGS);
          }
          else
          
            if(!dispatchLogin.payload.isEmailVerified){
              setShowExpiryMessage(false);
                dispatch(validateEmail());
                setVerifyItem("email")
                setShowVerifyModal(true)
            }
            else if(!dispatchLogin.payload.isPhoneNumberVerified){
              setShowExpiryMessage(false);
                dispatch(validatePhoneNumber());
                setVerifyItem("phone");
                setShowVerifyModal(true);
            }

           
            // else if(!dispatchLogin.payload.isRecaptured){
            //     dispatch(generateRecaptureLink(dispatchLogin.payload.pin));
            //     setShowRecaptureModal(true);
            // }
            else {
                // dispatch(getKYCStatus(dispatchLogin.payload.pin)).then(res=>{
                //     if(res.payload === null){
                //         window.location.replace(RouteNames.ONBOARDING)
                //     } else {
                //         window.location.replace(RouteNames.DASHBOARD);
                //     }
                // })
                window.location.replace(RouteNames.DASHBOARD);
            }
        }, 500)
    }
  };

  const restartLogin = () =>{
      localStorage.removeItem("token")
      setTimeout(()=>{
          window.location.reload()
      }, 2000)
  }

  const onItemVerified = ()=>{
      if(verifyItem === "email") {
          setSuccessModalText("Email verification Successful");
      } else {
          setSuccessModalText("Phone number successfully verified");
      }
      setShowSuccessModal(true);
      setShowVerifyModal(false)
      restartLogin();
    }


    const onChangePasswordVerified = ()=>{
      
          setSuccessModalText("Password has been changed successfully!.");
      
      setShowSuccessModal(true);
      setShowChangePasswordModal(false)
      restartLogin();
    }

  return (
    <AuthLayout>
      <VerifyEmailOrPhone
          item={verifyItem}
          showModal={showVerifyModal}
          onClose={()=>{setShowVerifyModal(false)}}
          onSuccess={onItemVerified}
      />
      <SuccessModal
          showModal={showSuccessModal}
          onClose={()=>setShowSuccessModal(false)}
          note={successModalText}
      />
      <RecaptureModal
          showModal={showRecaptureModal}
          onClose={()=>setShowRecaptureModal(false)}
          onSuccess={restartLogin}
      />

      <ChangePasswordModal item={verifyItem}
          showModal={showChangePasswordModal}
          onClose={()=>{setShowChangePasswordModal(false)}}
          onSuccess={onChangePasswordVerified}
      />
      <div className="login">
        <div className="login_head">
          <span>Don't have an account?</span>
          <Link to={RouteNames.SIGNUP} className="ml-4 btn btn-outline">
            Sign up
          </Link>
        </div>
        <div className="login_form">
          <h1 className="login_form_head">Log In</h1>
          <button className="btn btn-outline google-btn">
            <img src={GoogleLogo} alt="" className="pr-4" />
            Log In Using Google
          </button>
          <Divider className="my-2" text="Or" />
          <div className="login_form_text">Log in using email address</div>
          <form className="pb-8">
            <div className="input_container">
              <label className="input_title" htmlFor="email">
                Email Address/Username
              </label>
              <input
                id="email"
                className="input_field"
                disabled={isLoading}
                type="text"
                placeholder={"Enter email address or Username"}
                {...register("userName")}
              />
              {errors.userName && (
                <ErrorViewer message={errors.userName.message as string} />
              )}
            </div>
            <div className="input_container">
              <label className="input_title" htmlFor="password">
                Password
              </label>
              <div className="input_password_cage">
                <input
                  id={"password"}
                  className="input_field"
                  disabled={isLoading}
                  type={!showPassword ? "password" : "text"}
                  placeholder={"Enter password"}
                  {...register("password")}
                />
                <span onClick={() => setShowPassword(!showPassword)}>
                  {showPassword ? <FiEye /> : <FiEyeOff />}
                </span>
              </div>
              {errors.password && (
                <ErrorViewer message={errors.password.message as string} />
              )}
            </div>

            <button
              onClick={handleSubmit(onSubmit)}
              className="btn btn-primary btn-primary-full"
              disabled={isLoading}
            >
              {!isLoading ? (
                "Log In"
              ) : (
                <LoadingSpinner color={"#305F32"} backgroundColor={""} />
              )}
            </button>
          </form>
          <div className="text-center">
            <Link
              to={RouteNames.FORGOT_PASSWORD}
              className="btn btn-text btn-text-full"
            >
              Forgot Password?
            </Link>
          </div>
        </div>
      </div>
    </AuthLayout>
  );
};

export default Login;
